import { Row, Col } from 'antd'
import _ from 'lodash'
import classNames from 'classnames'
import stringHash from 'string-hash'
import { Loader } from '@vzmi/shp_shared_compo'
import styles from './SaleRanking.css'

import { NoData } from '../../Common/StatePage'
import SPBaseModule from '../../../lib/SPBaseModule'
import { SaleStatHelper } from './Shared'
import { getBaseMomentByNoonGap } from '../../../../lib/renderUtil'
import { StatsCard } from './StatsCard/StatsCard'
import { PeriodInformation } from './PeriodInformation/PeriodInformation'
import DashboardSectionBody from '../../Common/DashboardSection/DashboardSectionBody'

const RankingCardList = ({ items }) => {
  const listItems = !_.isEmpty(items)
    ? items.map(
      rankingItem => {
        const { ranking, zoneName } = rankingItem
        const key = stringHash(zoneName)
        const replacedRanking = ranking.replace('-', '~')
        return (
          <Col
            span={6}
            key={key}
          >
            <StatsCard
              title='預設以前七天訂購成本總額進行排名'
              titleContent={zoneName}
              content={`#${replacedRanking}`}
            />
          </Col>
        )
      })
    : null

  return (
    <Row>
      {listItems}
    </Row>
  )
}

class SaleRanking extends SPBaseModule {
  constructor (props) {
    super(props)
    // 資料統計區間預設為前七天、每日中午更新
    const baseMoment = getBaseMomentByNoonGap()
    const periodText = `${baseMoment.clone().subtract(7, 'days').format('MM/DD')}~${baseMoment.format('MM/DD')}`

    this.state = {
      periodText,
      data: []
    }
  }

  componentDidMount () {
    const { fetchRankingsStats } = this.props
    this.promiseStateWrapper(fetchRankingsStats())
      .then((res) => {
        if (!res.error) {
          return _.get(res, 'payload.stats[0]', null)
        }
      })
      .then((rankingStat) => {
      /** set up success state */
        this.setIsSuccess(true)
        if (rankingStat) {
          const { periodSegment = {} } = rankingStat
          // check if period existed
          const periodText = _.isEmpty(periodSegment) ? this.state.periodText : SaleStatHelper.formatPeriodSegment(periodSegment)
          this.setState({
            periodText,
            data: _.get(rankingStat, 'rankings', [])
          })
        }
      })
  }

  render () {
    const { className } = this.props
    const { periodText, data, isLoading, isError } = this.state
    const clz = classNames(styles.SaleRanking, {
      [className]: !!className
    })
    return (
      <div
        className={clz}
        data-role='sale-ranking'
      >
        <PeriodInformation noPaddingTop>
          {`資料統計區間：${periodText} (預設為前七天、每日中午更新)`}
        </PeriodInformation>
        <DashboardSectionBody>
          <Loader
            className={styles.rankingLoader}
            loaded={!isLoading}
          >
            {
              isError
                ? this.renderIOError()
                : (
                  _.isEmpty(data)
                    ? <NoData iconType='history' />
                    : <RankingCardList items={data} />
                )
            }
          </Loader>
        </DashboardSectionBody>
      </div>
    )
  }
}

export default SaleRanking
